import clipboard3 from "vue-clipboard3";
import { reactive, onMounted, getCurrentInstance, onBeforeUnmount } from "vue";
import { useRouter, useRoute } from "vue-router";

import { ElMessage } from 'element-plus/es';
import 'element-plus/es/components/base/style/css';
import 'element-plus/es/components/message/style/css';
export default {
  name: "ServicePhone",
  props: {},
  setup() {
    const {
      toClipboard
    } = clipboard3();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    let data = reactive({
      servicePhoneList: []
    });
    onMounted(() => {
      selectCustomerServiceNumber();
    });
    const selectCustomerServiceNumber = async () => {
      const res = await globalProperties.$api.selectCustomerServiceNumber();
      data.servicePhoneList = res;
    };
    //复制客服电话
    const copyPhone = async customerServiceNumber => {
      await toClipboard(customerServiceNumber);
      ElMessage({
        type: "success",
        message: "已复制"
      });
    };
    return {
      data,
      copyPhone
    };
  }
};